import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { ButtonDirective } from 'primeng/button';

export interface PatientListDialogData {
  type: string;
  prompt: string;
  buttonLabel: string;
  patients: Patient[];
}

@Component({
  selector: 'app-patient-list-dialog',
  templateUrl: './patient-list-dialog.component.html',
  styleUrls: ['./patient-list-dialog.component.scss'],
  standalone: true,
  imports: [ButtonDirective],
})
export class PatientListDialogComponent implements OnInit {
  prompt = '';
  buttonLabel = '';
  type = '';
  displayedColumns: string[] = ['id', 'name'];
  dataSource: Patient[] = [];
  selectedPatients: any[] = [];
  selectedRows: number[] = [];

  constructor(public dialogRef: DynamicDialogRef, public config: DynamicDialogConfig) { }

  ngOnInit(): void {
    this.prompt = this.config.data.prompt;
    this.buttonLabel = this.config.data.buttonLabel;
    this.dataSource = this.config.data.patients;
    this.type = this.config.data.type;
  }

  /**
   * Quits dialog without assigning patient to the student.
   */
  onNoClick(): void {
    this.dialogRef.close();
  }

  /**
   * Add selected row into the selected patient array to be returned once dialog closes.
   * Different logic applies for studentPatient type as it requires entire patient data
   * whereas default (patient) type only requires patient's uid
   *
   * @param {Patient} row   Patient data of the selected row
   * @param {number} index  Index number of selected row
   */
  selectPatient(row: Patient, index: number): void {
    const pid = row.getId();

    // If patient has been selected already, de-select it; otherwise, add
    // patient ID and index to arrays
    if (this.selectedPatients.includes(pid)) {
      this.selectedPatients = this.selectedPatients.filter((id) => id != pid);
      this.selectedRows = this.selectedRows.filter((i) => i != index);
    }
    // Same as above, but modified conditional statement for studentPatient
    else if (this.selectedPatients.find((x) => x.id === pid)) {
      this.selectedPatients = this.selectedPatients.filter((row) => row.getId() != pid);
      this.selectedRows = this.selectedRows.filter((i) => i != index);
    } else {
      switch (this.type) {
        case 'studentPatient':
          this.selectedPatients.push(row);
          this.selectedRows.push(index);
          break;
        default:
          this.selectedPatients.push(row.getId());
          this.selectedRows.push(index);
      }
    }
  }

  /**
   * Returns appropriate boolean value if the index value of the row
   * is included in the selectedRows array
   *
   * @param index Row's index number
   * @returns Whether or not the index passed to the function is in the
   * selectedRows array.
   */
  isSelected(index: number): boolean {
    return this.selectedRows.includes(index);
  }
}
